import { mapIndicatorDataFrom } from './utils.js';
import { thresholdPlot } from './XYChartThresholdIndicators.sty.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { ThresholdIndicator } from '../../../core/components/threshold-bar/indicators/ThresholdIndicator.js';
import { useGetThresholds } from '../../hooks/useGetThresholds.js';
import { useXYChartData } from '../../hooks/useXYChartData.js';
import { useXYChartScales } from '../../hooks/useXYChartScales.js';
import { useHoveredThresholdState } from '../../store/selectors.js';

export const XYChartThresholdIndicators = () => {
  const { thresholds, none } = useGetThresholds();
  const { width } = useGridPlotSize();
  const axisIdToScales = useXYChartScales();
  const hoveredThresholdId = useHoveredThresholdState();
  const { axes } = useXYChartData();

  if (none) {
    return null;
  }

  return (
    <svg className={thresholdPlot}>
      {thresholds.map((threshold) => {
        // TODO: workaround to dont let chart break. follow up APPDEV-16553
        // workaround applied after adding the new filtering series | toggling visible axis
        // we should refactor how we manage the threshold instead

        if (!axes.find((axis) => axis.id === threshold.yAxisId)) {
          return undefined;
        }

        const data = mapIndicatorDataFrom({
          axisIdToScales,
          threshold,
          width,
        });

        return (
          <ThresholdIndicator
            key={`threshold-indicator-${threshold.id}`}
            data={data}
            color={threshold.color}
            strokeOnly={threshold.strokeOnly}
            isActive={hoveredThresholdId === threshold.id}
          />
        );
      })}
    </svg>
  );
};
